import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-grid-ordernr",
  templateUrl: "./field-set-grid-ordernr.component.html",
  styles: [],
})
export class FieldSetGridOrderNrComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
